import { t } from 'i18next';
import React, { useCallback, useMemo, useState } from 'react';

import ICONS, { IconName } from 'Components/foundation/icons';
import STooltip from 'Components/structural/STooltip/STooltip';

import styles from './Item.style';

type ItemProps = {
  label: string;
  icon: IconName;
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
};

const Item: React.FC<ItemProps> = ({ label, icon, active, disabled, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const Icon = useMemo(() => (disabled ? ICONS['lock-2'] : ICONS[icon]), [disabled, icon]);
  const labelStyle = useMemo(() => (active ? styles.labelActive : styles.label), [active]);

  const containerStyle = useMemo(() => {
    if (active) return styles.containerActive;
    if (isHovered && !disabled) return styles.containerHover;
    return {};
  }, [active, isHovered, disabled]);

  const handleClick = useCallback(() => {
    if (disabled) return;
    onClick();
  }, [disabled, onClick]);

  return (
    <>
      <div
        data-tooltip-id={`${label}-tooltip`}
        style={{ ...styles.container, ...containerStyle }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
      >
        <Icon color={labelStyle.color} />
        <p style={labelStyle}>{label}</p>
      </div>
      {isHovered && disabled && (
        <STooltip
          id={`${label}-tooltip`}
          content={t('analytics:dashboard.tooltip.coming_soon')}
          position="top"
          defaultIsOpen
        />
      )}
    </>
  );
};

export default Item;
